
export default {
  components: {
    ToolTip: () => import(/* webpackChunkName: "ToolTip" */ '../../ToolTip')
  },
  props: ['value', 'field'],
  computed: {
    advancedOptionListResponsiveView () { return this.$store.state.store.advancedOptionListResponsiveView }
  }
}
